/* eslint-disable react/prop-types */
import { withStyles } from '@material-ui/core';
import React from 'react'; // eslint-disable-line
import { ExpansionPanel } from '../../../../../../forms/form-components/expansion-panel/expansion-panel';
import styles, { StyledComponent } from '../../../../../../styles/styles';
import { PersonalDetailsView } from '../../details/personal-detail';
import { AddressDetailsView } from '../../details/address-details';
import { ContactDetailsView } from '../../details/contact-details';
import { DoctorPracticeDetailsView } from '../../details/doctor-practice-details';
import { MedicalAidDetailsView } from '../../details/medical-aid-details';
import { OtherDetailsView } from '../../details/other-details';
import { FormDetails } from '../../form-details-reducer';
import { OtherDisabilityInsuranceView } from '../../details/other-disability-insurance';
import { Nullable } from '../../../../../../shared-types';
import { ClaimType } from '../../../../../../claim/claim-types';
import { MedicalInformationDetailsView } from '../../details/medical-information';

interface BaseProps {
    formDetails?: FormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}

interface Props extends StyledComponent, BaseProps {}

const lifeAssuredDetailsView: React.FunctionComponent<Props> = ({
    formDetails,
    disableEditButton,
    claimType,
}) => {
    const isRetrenchmentClaim = claimType === ClaimType.Retrenchment;
    return (
        <ExpansionPanel name="Life Assured details" style={{ marginLeft: -24, marginRight: -24 }}>
            <React.Fragment>
                <PersonalDetailsView
                    type="LifeAssured"
                    formDetails={formDetails}
                    disableEditButton={disableEditButton}
                />
                {isDreadOrTerminal() && (
                    <AddressDetailsView
                        type="LifeAssured"
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
                {isDreadOrTerminal() && (
                    <ContactDetailsView
                        type="LifeAssured"
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
                {isDreadOrTerminal() && (
                    <MedicalInformationDetailsView
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
                {claimType === ClaimType.Disability && (
                    <DoctorPracticeDetailsView
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
                <MedicalAidDetailsView
                    formDetails={formDetails}
                    disableEditButton={disableEditButton}
                />
                {isRetrenchmentClaim && (
                    <DoctorPracticeDetailsView
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
                {!isRetrenchmentClaim && (
                    <OtherDetailsView
                        formDetails={formDetails}
                        disableEditButton={disableEditButton}
                    />
                )}
                {!isRetrenchmentClaim && <OtherDisabilityInsuranceView formDetails={formDetails} />}
            </React.Fragment>
        </ExpansionPanel>
    );
    function isDreadOrTerminal() {
        return claimType === ClaimType.Dread || claimType === ClaimType.TerminalIllness;
    }
};

export const LifeAssuredDetailsView = withStyles(styles)(lifeAssuredDetailsView);
